import DOMPurify from 'dompurify';

const SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file|sms):|[^&:/?#]*(?:[/?#]|$))/gi;

/** A pattern that matches safe data URLs. It only matches image, video, and audio types. */
const DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i;

const sanitize = (dirty, custom) => DOMPurify.sanitize(dirty, custom || { ADD_ATTR: ['data'], ALLOW_DATA_ATTR: true });

const transformTextFromTextEditor = (text) => sanitize(text);

const _sanitizeUrl = (u) => {
    const url = String(u);
    if (!url || url === 'null' || url.length === 0) {
        return '';
    }
    if (url.match(SAFE_URL_PATTERN) || url.match(DATA_URL_PATTERN)) {
        return url;
    }
    return '';
};

const sanitizeUrl = (url) => _sanitizeUrl(String(url).trim());

export default {
    transformTextFromTextEditor,
    sanitize,
    sanitizeUrl,
};
